import React from 'react';
import { GetColab } from '../../modules/Colab/types';
import { useColabContext } from './ColabContext';
import ColabCategoryCombobox from './colabCategoryCombobox';
import { getCategoryOptions } from './colabOptions';

type ColabDetailsProps = { colabEntity: GetColab; compact?: boolean };

const colabCategory: React.FC<ColabDetailsProps> = ({ colabEntity, compact = false }) => {
  const { data, updateCategory } = useColabContext();
  const record = data.find(e => e.partitionKey === colabEntity.partitionKey && e.rowKey === colabEntity.rowKey);
  const categoryOptions = getCategoryOptions();
  if (!record) return null;
  const selectedCategory = record.category || '';

  const handleCategoryChange = async (value: string) => {
    try {
      updateCategory(colabEntity.partitionKey, colabEntity.rowKey, value);
    } catch (error) {
      console.error('Error updating colab record category on combobox change:', error);
    }
  };

  return (
    <div>
      <ColabCategoryCombobox
        id={colabEntity.rowKey}
        value={selectedCategory}
        options={categoryOptions}
        onChange={handleCategoryChange}
        placeholder="Uncategorized"
        emptyOptionLabel="Uncategorized"
        className={`${compact ? 'colab-table-select colab-table-select--category' : 'colab-drawer-select'} max-w-full`}
      />
    </div>
  );
};

export default colabCategory;
